<template>
  <div :id="user.id" class="list-box-container"
       @mouseup="($_can('users.show') ||
         $_can('users.view-own'))"
  >
    <template v-if="userLoading">
      <div class="lds-ellipsis px-4 py-4">
        <div />
        <div />
        <div />
      </div>
    </template>
    <template v-else>
      <router-link :to="{ name: 'UsersEdit', params: { id: `${user.id}`}, query: { data: `${q ? `?q=${encodeURIComponent(q)}` : ''}`}}">
        <div class="d-flex list-box-header col-12 pointer">
          <div class="pl-0 list-box-header-left col-lg-9 col-6 pr-3">
            <div class="pl-0 d-flex align-items-center col-lg-4 col-7">
              <div class="list-box-status align-items-start col-xl-3 col-lg-4 col-5">
                <span class="pointer">
                  <span class="ref-id">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 0C7.168 0 0 7.168 0 16C0 24.832 7.168 32 16 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 16 0ZM16 4.8C18.656 4.8 20.8 6.944 20.8 9.6C20.8 12.256 18.656 14.4 16 14.4C13.344 14.4 11.2 12.256 11.2 9.6C11.2 6.944 13.344 4.8 16 4.8ZM16 27.52C12 27.52 8.464 25.472 6.4 22.368C6.448 19.184 12.8 17.44 16 17.44C19.184 17.44 25.552 19.184 25.6 22.368C23.536 25.472 20 27.52 16 27.52Z" fill="#E4E8EC" />
                    </svg>
                  </span>
                </span>
              </div>
              <div class="claim-customer col-12 pl-1 wrap">
                <span class="full-name">{{ user.first_name }} {{ user.last_name }}</span>
                <br />
                {{ user.username }}
              </div>
            </div>
            <div class="d-flex align-items-center mobilehide col-7 wrap">
              <div class="user-roles" v-if="user.roles">
                <div v-for="role in user.roles" :key="role.id">
                  <span
                    class="pr-2"
                    :class="role.department ? [
                      role.department.id === 4 ? 'dispatch-roles ' : '',
                      role.department.id === 2 ? 'sales-roles ' : '',
                      role.department.id === 3 ? 'claims-roles ' : '',
                      role.department.id === 1 ? 'management ' : ''
                    ] : ''"
                  >
                    {{ role.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="list-box-header-right col-lg-3 col-6 pl-4">
            <label />
            <div class="d-flex align-items-center col-3 col-lg-5 wrap">
              <i class="fa fa-circle" :class="[user.user_status.name === 'Active' ? 'active' : 'inactive']" />
              <span>
                {{ user.user_status.name }}
              </span>
            </div>
            <div class="list-box-header-options justify-content-end col-9 col-xl-7 col-lg-8 pointer">
              <div class="options pl-4">
                <div class="options-buttons" v-if="$_can('clusters.users.update')">
                  <div class="dropdown" @click.prevent>
                    <button type="button" class="btn btn-secondary add-filter" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false"
                    />
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item nav-link btn" @click="openUserStatusModal">
                        Change user status
                      </button>
                    </div>
                  </div>
                  <button class="btn btn-secondary expand-claims" @click.prevent.stop="toggleUser(user.id)">
                    <i class="fa fa-caret-down caret" :class="{ rotate: expanded.includes(user.id) }" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
      <hr :class="[expanded.includes(user.id) ? 'w-100 divider' : 'hidden']" />
      <div class="d-flex flex-column" :class="[expanded.includes(user.id) ? 'list-box-expanded' : 'hidden']">
        <div class="d-flex col-12 p-0">
          <div class="d-flex flex-column justify-content-start col-lg-3 col-6">
            <div class="contact-info mb-4">
              <span class="claim-heading pb-2">
                Email
              </span>
              <span class="email">
                {{ user.email }}
              </span>
              <span class="claim-heading pt-4 pb-2">
                Phone
              </span>
              <span class="email">
                {{ phoneMask.maskedPhone(user.phone) }}
              </span>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-start col-lg-9 col-6">
            <div class="contact-info mb-4">
              <span class="claim-heading pb-2">
                Carriers
              </span>
              <div class="d-flex" v-if="user.carriers">
                <div class="row col-12">
                  <template v-for="(carrier, index) in user.carriers">
                    <div :key="index">
                      <span v-if="index !== 0">, </span>{{ carrier.name }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="contact-info mobileshow">
              <span class="claim-heading pb-2">
                Roles
              </span>
              <div class="d-flex" v-if="user.roles">
                <div v-for="role in user.roles" :key="role.id">
                  <span
                    class="pr-2"
                    :class="[
                      role.id === 27 || role.id === 28 ? 'dispatch-roles' : '',
                      role.id === 30 || role.id === 31 ? 'sales-roles' : '',
                      role.id === 25 || role.id === 26 ? 'claims-roles' : '',
                      role.id === 1 ? 'management' : ''
                    ]"
                  >
                    {{ role.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- User status modal -->
      <modal v-if="userStatusModal"
             @close="userStatusModal = false"
             :size="'modal-large'"
             :close-strict="true"
      >
        <div slot="header">
          <div class="row">
            <div class="col-10">
              <div>
                <h4>{{ user.user_status.name }} - Change user status</h4>
              </div>
            </div>
          </div>
        </div>
        <div slot="body">
          <div class="select-wrap">
            <label>Status</label>
            <simple-select v-model="user.user_status_id"
                           :options="userStatuses"
                           @change="clearError($event)"
            />
          </div>
          <error-field :errors="errors" field="cluster_user_id" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12">
              <button type="button"
                      class="btn btn-primary pull-right"
                      @click="changeStatus"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </modal>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState } from 'vuex';
import Modal from '../Modal';
import PhoneMask from '../../classes/PhoneMask';
import Errors from '../../classes/Errors';

export default {
  components: {
    Modal,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    expanded: {
      type: Array,
      default: () => [],
    },
    q: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    userLoading: false,
    userStatusModal: false,
    userStatusId: null,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      userStatuses: state => state.values.userStatuses,
    }),
  },
  methods: {
    getUser(userMessage) {
      axios
        .get(`clusters/users/${this.user.id}`)
        .then(res => {
          this.user = res.data.data;
          if (userMessage) toastr.success(userMessage);
        })
        .finally(() => {
          this.userLoading = false;
        });
    },
    openUserStatusModal() {
      this.userStatusModal = true;
    },
    changeStatus() {
      this.userLoading = true;
      this.userStatusId = this.user.user_status_id;
      axios
        .put(`clusters/users/${this.user.id}`, {
          cluster_id: this.user.cluster_id,
          companies: this.user.companies.map(company => company.id),
          carriers: this.user.carriers.map(carrier => carrier.id),
          email: this.user.email,
          email_verified: this.user.email_verified,
          first_name: this.user.first_name,
          id: this.user.id,
          images: this.user.images,
          last_name: this.user.last_name,
          phone: this.user.phone,
          phone_verified: this.user.phone_verified,
          roles: this.user.roles.map(role => role.id),
          user_status: this.user_status,
          user_status_id: this.userStatusId,
          user_type_id: this.user_type_id,
          username: this.user.username,
        })
        .then(() => {
          this.getUser('Successfully updated user');
        })
        .finally(() => {
          this.userStatusModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    toggleUser(id) {
      this.$emit('expanded', id);
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    viewInNewTab(event, id) {
      this.$emit('setFiltersSaved');
      const routeData = this.$router.resolve({
        path: `/users/edit/${id}`,
        query: { data: this.q },
      });
      window.open(routeData.href, '_blank');
    },
    view(event, id) {
      this.$router.push(`/users/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q)}` : ''}`);
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  color: inherit !important;
  width: 100%;
  text-decoration: none;
}
a:hover {
  color: inherit !important;
  text-decoration: none !important;
}
.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 45px;
  padding-top: 11px;
}

.lds-ellipsis div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 10px !important;
  background: #e3e3e3;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}
.claim-closed {
  background-color: #2962ff;
  display: flex;
  color: #fff;
  border-radius: 4px;
  padding: 14px;
  height: 52px;
}
.list-box-status {
  align-items: normal;
}
.expand-claims {
  height: 40px;
  width: 40px;
  margin-left: 7px;
}
.claim-closed {
  justify-content: space-between;
}
.fa-circle {
  position: relative;
  padding-right: 11px;
}
.user-roles {
  display: flex;
}
.active {
  color: #2db400;
  font-size: 11px;
}
.inactive {
  color: #ff4d4d;
  font-size: 11px;
}
.full-name {
  font-weight: 500;
  font-size: 16px;
  color: #4c5669;
}
.wrap {
  min-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/UsersBlock.vue